import React, { useState, useEffect } from 'react'
import { Typography, Grid, makeStyles } from '@material-ui/core'

import CrossMark from '../../../../Assets/Images/icons/crossMark'

import { styles } from './styles'

const useStyles = makeStyles(() => styles)

const Banner = ({
  id = 'default-banner',
  cypress_ids,
  title,
  description,
  action,
  Icon,
  isShow,
}) => {
  const classes = useStyles()
  const loginSessionID = JSON.stringify(localStorage.apiKey)
  const [show, setShow] = useState(isShow)

  useEffect(() => {
    const bannerState = localStorage.getItem(id)
    if (bannerState === loginSessionID) {
      setShow(false)
    }
  }, [])

  const handleClose = () => {
    setShow(!show)
    localStorage.setItem(id, loginSessionID)
  }

  return show ? (
    <Grid
      container
      className={classes.container}
      cypress_id={cypress_ids.container}
    >
      <Grid item xs={12} sm={6} className={classes.textContainer}>
        <Typography cypress_id={cypress_ids.title} className={classes.title}>
          {title}
        </Typography>
        <Typography cypress_id={cypress_ids.description}>
          {description}
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}
        sm={4}
        className={classes.iconContainer}
        cypress_id={cypress_ids.icon}
      >
        <Icon className={classes.icon} />
      </Grid>
      <Grid item xs={12} sm={2} className={classes.buttonContainer}>
        <button
          className={classes.button}
          onClick={action.onClick}
          cypress_id={cypress_ids.button}
        >
          {action.button}
        </button>
      </Grid>
      <span className={classes.closeBtn} cypress_id={cypress_ids.close}>
        <CrossMark
          width="24"
          height="24"
          stroke="#292D32"
          className={classes.crossMark}
          onClick={handleClose}
        />
      </span>
    </Grid>
  ) : null
}

export default Banner
